import { EsriHelpers } from '../_helpers/EsriHelpers';

export enum HistoryRecurrence {
  EveryDay = 7,
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Minutes15 = 15,
  Minutes30 = 30,
  Hour = 60,
}

export interface HistoryOptions {
  recurrence: HistoryRecurrence;
  step: number;
  /** Format : HH:mm */
  recurrenceHourStart: string;
  /** Format : HH:mm */
  recurrenceHourEnd: string;
  consultation: {
    start: Date;
    end: Date;
  };
}

export class History implements HistoryOptions {
  recurrence: HistoryRecurrence;
  step: number;
  recurrenceHourStart: string;
  recurrenceHourEnd: string;
  consultation: { start: Date; end: Date };

  private whereClauseFields: {
    fieldDateStart: string;
    fieldDateEnd: string;
  };

  constructor(
    options: HistoryOptions,
    whereClauseFields: {
      fieldDateStart: string;
      fieldDateEnd: string;
    }
  ) {
    this.recurrence = options.recurrence;
    this.step = options.step;
    this.recurrenceHourStart = options.recurrenceHourStart;
    this.recurrenceHourEnd = options.recurrenceHourEnd;
    this.whereClauseFields = whereClauseFields;

    this.consultation = {
      start: this.calculateDate(options.consultation.start, this.recurrenceHourStart, 0),
      end: this.calculateDate(options.consultation.end, this.recurrenceHourEnd, 0),
    };
  }

  formatWhereClause(start: Date, end: Date): string {
    // const endWhereClause = `((${this.whereClauseFields.fieldDateEnd} is NULL) OR (${this.whereClauseFields.fieldDateEnd} <= TIMESTAMP '${EsriHelpers.formatDateToStringForQuery(end)}'))`
    const startWhereClause = `${this.whereClauseFields.fieldDateStart} >= TIMESTAMP '${EsriHelpers.formatDateToStringForQuery(start)}'`;
    const endWhereClause = `${this.whereClauseFields.fieldDateEnd} <= TIMESTAMP '${EsriHelpers.formatDateToStringForQuery(end)}'`;
    const endNullWhereClause = `(${this.whereClauseFields.fieldDateEnd} IS NULL)`;

    // return `(${startWhereClause} AND ${endWhereClause}) OR (${startWhereClause} AND ${endNullWhereClause})`;
    return `(${startWhereClause}) AND (${endWhereClause})`;
    // return `${startWhereClause}`;
  }

  private calculateDate(inputDate: Date, recurrenceHour: string, value: number) {
    const hoursMins = recurrenceHour.split(':').map((x) => Number(x));
    const date = new Date(inputDate);
    date.setDate(date.getDate() + value);
    date.setHours(hoursMins[0], hoursMins[1], 0, 0);
    return date;
  }
}
